module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Commode1-808189e58375f6e54f7331aaa3326aab.svg";